// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { Link } from 'react-resource-router';

import { B100, B50 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const RouterLink = styled(Link)<{ isSelected?: boolean }>`
	[data-item-title] {
		line-height: 1.2;
		color: ${(props) => (props.isSelected ? token('color.text', 'rgb(66, 82, 110)') : 'inherit')};
	}

	& [data-item-title] {
		color: ${(props) => (props.isSelected ? token('color.text', 'rgb(66, 82, 110)') : 'inherit')};
	}

	:focus,
	:visited,
	:active {
		position: relative;
		outline: 0;
		text-decoration: inherit;
	}

	:active {
		background-color: ${token('color.background.selected.pressed', B50)};
		box-shadow: ${token('elevation.shadow.overlay', 'transparent')};

		& [data-item-title] {
			color: ${token('color.text', 'rgb(66, 82, 110)')};
		}
	}

	:focus {
		box-shadow: ${token('color.border.focused', B100)} 0 0 0 2px inset;
	}
`;
